import { createFeatureSelector, createSelector } from '@ngrx/store';

import { greenHouseMapToRowList } from 'app/shared/features/map-row-selector/utils';
import { greenHouseMapFeatureKey } from 'app/state/green-house-map/green-house-map.reducer';
import {
    FilteredGreenHouseMapWithRowNumbers,
    GreenHouseMapState,
} from 'app/state/green-house-map/greenhouse-map.state';

export const selectGreenHouseMapState = createFeatureSelector<GreenHouseMapState>(greenHouseMapFeatureKey);

export const selectGreenHouseMapList = createSelector(
    selectGreenHouseMapState,
    (state) => state.greenHouseMapList,
);

export const selectSearchParams = createSelector(
    selectGreenHouseMapState,
    (state) => state.greenHouseMapFilters?.searchParams,
);

export const selectFilteredGreenHouseMapWithRowNumbers = createSelector(
    selectGreenHouseMapState,
    ({ greenHouseMapFilters, greenHouseMapList }): FilteredGreenHouseMapWithRowNumbers => {
        if (!greenHouseMapFilters) return { map: undefined, filteredRowNumbers: [] };
        const map = greenHouseMapList.find((map) => map.number === greenHouseMapFilters.mapNumber);
        return {
            map,
            filteredRowNumbers: greenHouseMapFilters.filteredRowNumbers,
            recentRowNumber: greenHouseMapFilters.recentRowNumber,
        };
    },
);

export const selectRowByNumber = (rowNumber: number) =>
    createSelector(selectGreenHouseMapList, (mapList) =>
        mapList.flatMap(greenHouseMapToRowList).find((row) => row?.number === rowNumber),
    );

export const selectRowListByNumbers = (rowNumbers: number[]) =>
    createSelector(selectGreenHouseMapList, (mapList) =>
        rowNumbers.map((rowNumber) => {
            return mapList.flatMap(greenHouseMapToRowList).find((row) => row?.number === rowNumber)?.name;
        }),
    );
